import React, { Fragment, useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import {
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  MAX_OPEN_FILE_SIZE,
  PRODUCT_TYPE
} from '../../define/global';
import iconOpen from '../../img/ico_open.png';
import iconOpen2X from '../../img/ico_open@2x.png';
import openHoverIcon from '../../img/ico_open_hover.png';
import openHoverIcon2X from '../../img/ico_open_hover@2x.png';

import iconOpenHwp from '../../img/ico_open_hwp.png';
import iconOpenHwp2x from '../../img/ico_open_hwp@2x.png';
import iconHoverHwp from '../../img/ico_open_hwp_hover.png';
import iconHoverHwp2x from '../../img/ico_open_hwp_hover@2x.png';

import iconOpenSheet from '../../img/ico_open_sheet.png';
import iconOpenSheet2x from '../../img/ico_open_sheet@2x.png';
import iconHoverSheet from '../../img/ico_open_sheet_hover.png';
import iconHoverSheet2x from '../../img/ico_open_sheet_hover@2x.png';

import iconOpenSlide from '../../img/ico_open_slide.png';
import iconOpenSlide2x from '../../img/ico_open_slide@2x.png';
import iconHoverSlide from '../../img/ico_open_slide_hover.png';
import iconHoverSlide2x from '../../img/ico_open_slide_hover@2x.png';

import iconOpenWord from '../../img/ico_open_word.png';
import iconOpenWord2x from '../../img/ico_open_word@2x.png';
import iconHoverWord from '../../img/ico_open_word_hover.png';
import iconHoverWord2x from '../../img/ico_open_word_hover@2x.png';

import ga from '../../utils/gaConnect';
import { useTranslation } from 'react-i18next';
import { useAppDataSliceSelector } from '../../store/modules/appData';

const HwpHover = css`
  background-color: #ebf4ff;
`;

const SheetHover = css`
  background-color: #edfaeb;
`;

const SlideHover = css`
  background-color: #fff0dd;
`;

const NoneBackground = css`
  border: 1px dashed #a5afb8;
  background-color: #fafafa;
`;

const HwpBackground = css`
  border: 1px dashed #3377bc;
  background-color: #fcfeff;
`;

const SheetBackground = css`
  border: 1px dashed #66a643;
  background-color: #fdfffc;
`;

const SlideBackground = css`
  border: 1px dashed #fd8900;
  background-color: #fffefc;
`;

const DnDBoxStyle = styled.div`
  width: 562px;
  height: 351px;
  border-radius: 4px;
  margin: 0px 8px 0px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
  overflow: hidden;
  ${({ isWhaleSpace }) =>
    isWhaleSpace &&
    css`
      width: 273px;
    `}
  ${({ background }) => background}
  ${({ isInDnDBox, hoverCss }) => isInDnDBox && hoverCss}
`;

const IconOpen = styled.img`
  width: 100px;
  height: 100px;
  pointer-events: none;
`;

const FirstContent = styled.div`
  width: 261px;
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  color: #2f3133;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  margin-top: 15px;
  margin-bottom: 6px;
  color: ${(props) => props.textColor};
`;

const SecondContent = styled.div`
  width: 261px;
  height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #aaadb0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  margin-bottom: 19px;
  color: ${(props) => props.textColor};
`;

function OpenWithDragNDrop({ children, openDocument }) {
  const { t } = useTranslation();
  const [isInDnDBox, setIsInDnDBox] = useState(false);
  const appDataSlice = useAppDataSliceSelector();

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsInDnDBox(true);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer.dropEffect = 'move';
    setIsInDnDBox(true);
  };

  const handledDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsInDnDBox(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsInDnDBox(false);
    let files = event.dataTransfer.files;
    if (files && files.length > 0) {
      openDocument(files, (executeTime, fileBlob) => {
        ga.event({
          category: '문서열기',
          action: '드래그앤드랍',
          label: '시작화면',
          value: executeTime
        });
        ga.event({
          category: '사용지표',
          action: '열람 문서 크기',
          label: '기기문서',
          value: fileBlob.size
        });
      });
    }
  };

  const getIcon = useCallback(() => {
    switch (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType) {
      case DOCUMENT_TYPE.HWP:
        return {
          icon: iconOpenHwp,
          icon2x: iconOpenHwp2x,
          hover: iconHoverHwp,
          hover2x: iconHoverHwp2x,
          background: HwpBackground,
          hoverCss: HwpHover,
          textColor1: '#437fbb',
          textColor2: '#88abd6'
        };
      case DOCUMENT_TYPE.SHEET:
        return {
          icon: iconOpenSheet,
          icon2x: iconOpenSheet2x,
          hover: iconHoverSheet,
          hover2x: iconHoverSheet2x,
          background: SheetBackground,
          hoverCss: SheetHover,
          textColor1: '#5f8f42',
          textColor2: '#8fb877'
        };
      case DOCUMENT_TYPE.SLIDE:
        return {
          icon: iconOpenSlide,
          icon2x: iconOpenSlide2x,
          hover: iconHoverSlide,
          hover2x: iconHoverSlide2x,
          background: SlideBackground,
          hoverCss: SlideHover,
          textColor1: '#db7700',
          textColor2: '#e29943'
        };
      case DOCUMENT_TYPE.WORD:
        return {
          icon: iconOpenWord,
          icon2x: iconOpenWord2x,
          hover: iconHoverWord,
          hover2x: iconHoverWord2x,
          background: HwpBackground,
          hoverCss: HwpHover,
          textColor1: '#437fbb',
          textColor2: '#88abd6'
        };
      default:
        return {
          icon: iconOpen,
          icon2x: iconOpen2X,
          hover: openHoverIcon,
          hover2x: openHoverIcon2X,
          background: NoneBackground,
          textColor1: '#2f3133',
          textColor2: '#aaadb0'
        };
    }
  }, []);

  const { icon, icon2x, hover, hover2x, hoverCss, background, textColor1, textColor2 } = getIcon();

  return (
    <DnDBoxStyle
      // isWhaleSpace={appDataSlice.productType === PRODUCT_TYPE.WITH_WHALE_SPACE}
      isInDnDBox={isInDnDBox}
      onDrop={(event) => handleDrop(event)}
      onDragOver={(event) => handleDragOver(event)}
      onDragLeave={(event) => handledDragLeave(event)}
      onDragEnter={(event) => handleDragEnter(event)}
      hoverCss={hoverCss}
      background={background}>
      {isInDnDBox ? (
        <IconOpen src={hover} srcSet={hover2x} />
      ) : (
        <IconOpen src={icon} srcSet={icon2x} />
      )}

      <FirstContent isInDnDBox={isInDnDBox} textColor={textColor1}>
        {t('OpenWithDragNDrop.DragDropDocument')}
      </FirstContent>
      <SecondContent isInDnDBox={isInDnDBox} textColor={textColor2}>
        {t('OpenWithDragNDrop.LimitFileSize', { MAX_OPEN_FILE_SIZE: MAX_OPEN_FILE_SIZE })}
      </SecondContent>
      {isInDnDBox === false && <Fragment>{children}</Fragment>}
    </DnDBoxStyle>
  );
}

export default OpenWithDragNDrop;
